export default __webpack_public_path__ + "static/media/sumeru3.169a429f.png";